import React, { useEffect, useState } from "react";
import OfferCardView from "./OfferCardView";
import LinearProgress from "@mui/material/LinearProgress";
import Alert from "@mui/material/Alert";
import Pagination from "@mui/material/Pagination";



const OffersViewContainerGrid = ({ children, nichoCode = "Dinero" }) => {
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [infoMsg, setInfoMsg] = useState("");

    // Pagination state
    const [page, setPage] = useState(1);
    const [limit] = useState(12);
    const [pageInfo, setPageInfo] = useState({
        currentPage: 1,
        totalPages: 0,
        totalOffers: 0,
        hasNextPage: false,
        hasPrevPage: false,
    });

    // Reset page when nicho changes
    useEffect(() => {
        setPage(1);
    }, [nichoCode]);

    useEffect(() => {
        const fetchOffers = async () => {
            setLoading(true);
            setErrorMsg("");
            setInfoMsg("");
            try {
                const url = `https://tueducaciondigital.site/testnode/getnicho?nichoCode=${encodeURIComponent(
                    nichoCode
                )}&limit=${limit}&page=${page}`;
                const response = await fetch(url);
                const data = await response.json();
                if (data.error) {
                    setErrorMsg("Ocurrió un error al obtener las ofertas.");
                    setOffers([]);
                    setPageInfo({
                        currentPage: page,
                        totalPages: 0,
                        totalOffers: 0,
                        hasNextPage: false,
                        hasPrevPage: page > 1,
                    });
                } else if (Array.isArray(data.data) && data.data.length === 0) {
                    setInfoMsg(data.message || "No se encontraron ofertas para este nicho.");
                    setOffers([]);
                    const totalOffers = data.info?.totalOffers ?? data.info?.totalItems ?? 0;
                    const totalPages = data.info?.totalPages ?? (Math.ceil(totalOffers / limit) || 0);
                    setPageInfo({
                        currentPage: data.info?.currentPage ?? page,
                        totalPages,
                        totalOffers,
                        hasNextPage: data.info?.hasNextPage ?? false,
                        hasPrevPage: data.info?.hasPrevPage ?? page > 1,
                    });
                } else {
                    setOffers(data.data || []);
                    const totalOffers = data.info?.totalOffers ?? data.info?.totalItems ?? (data.data?.length ?? 0);
                    const totalPages = data.info?.totalPages ?? (Math.ceil(totalOffers / limit) || 0);
                    setPageInfo({
                        currentPage: data.info?.currentPage ?? page,
                        totalPages,
                        totalOffers,
                        hasNextPage: data.info?.hasNextPage ?? page < totalPages,
                        hasPrevPage: data.info?.hasPrevPage ?? page > 1,
                    });
                }
            } catch (err) {
                setErrorMsg("No se pudo conectar con el servidor.");
                setOffers([]);
                setPageInfo({
                    currentPage: page,
                    totalPages: 0,
                    totalOffers: 0,
                    hasNextPage: false,
                    hasPrevPage: page > 1,
                });
            }
            setLoading(false);
        };
        fetchOffers();
    }, [nichoCode, page, limit]);

    const handlePageChange = (_event, value) => {
        setPage(value);
        // Optional: scroll to top of grid when page changes
        try {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch {}
    };

   return (
        <div
            style={{
                background: "transparent",
                width: "100%",
                height: "100%",
                minHeight: "600px",
                padding: "24px",
                boxSizing: "border-box",
            }}
        >
            {children}
            {loading && <LinearProgress sx={{ margin: "24px 0" }} />}
            {errorMsg && (
                <Alert severity="error" sx={{ margin: "24px 0" }}>
                    {errorMsg}
                </Alert>
            )}
            {infoMsg && !loading && !errorMsg && (
                <Alert severity="info" sx={{ margin: "24px 0" }}>
                    {infoMsg}
                </Alert>
            )}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(5, 1fr)",
                     gap: "60px 20px",
                    justifyItems: "center",
                    marginTop: "24px"
                }}
            >
                {!loading && !errorMsg && offers.map((oferta) => (
                    <OfferCardView key={oferta.id + oferta.Imagen} data={oferta} />
                ))}
            </div>
            {!loading && !errorMsg && pageInfo.totalPages > 1 && (
                <div className="offers-pagination-container">
                    <Pagination
                        count={pageInfo.totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        shape="rounded"
                        boundaryCount={1}
                        siblingCount={1}
                        showFirstButton
                        showLastButton
                    />
                </div>
            )}
        </div>
    );    
};

export default OffersViewContainerGrid;